module.exports = __webpack_public_path__ + "7a3cf1fb734f93ac3fb17b86f2f93de3.pdf";